module.exports = __webpack_public_path__ + "img/svg/whatsapp-green-6516ea82.svg";